var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Close, Menu } from '@amsterdam/asc-assets';
import React from 'react';
import Icon from '../../Icon/Icon';
import { TOGGLE_BUTTON_SIZE } from '../../shared/constants';
import ToggleButtonStyle from './ToggleButtonStyle';
const ToggleHandlerButton = (_a) => {
    var { iconOpen, iconClose, open, rotate, size } = _a, otherProps = __rest(_a, ["iconOpen", "iconClose", "open", "rotate", "size"]);
    const IconOpen = iconOpen || React.createElement(Menu, null);
    const IconClose = iconClose || React.createElement(Close, null);
    return (React.createElement(ToggleButtonStyle, Object.assign({ variant: "blank", size: TOGGLE_BUTTON_SIZE, open: !!open }, otherProps),
        React.createElement(Icon, Object.assign({}, { rotate, size }), open && !rotate ? IconClose : IconOpen)));
};
export default ToggleHandlerButton;
//# sourceMappingURL=ToggleButton.js.map